import { SATELLITE_LAYER_AND_SOURCE } from '../../utils/utils';
import { getMapUri } from '../../../config/uri';
export const generateSatellite = (map) => {
    map.addSource(SATELLITE_LAYER_AND_SOURCE, {
        type: 'raster',
        tiles: [`${getMapUri()}satellite/v4/mapbox.satellite/{z}/{x}/{y}.jpg90`]
    });
    const layers = map.getStyle().layers;
    const bottomLayer = layers.find((layer) => layer.type !== 'background');
    map.addLayer({
        id: SATELLITE_LAYER_AND_SOURCE,
        type: 'raster',
        source: SATELLITE_LAYER_AND_SOURCE
    }, bottomLayer.id);
    fillLayers(map, layers, 0);
};
export const deleteSatellite = (map) => {
    var _a;
    if ((_a = map.getSource(SATELLITE_LAYER_AND_SOURCE)) === null || _a === void 0 ? void 0 : _a.loaded()) {
        map === null || map === void 0 ? void 0 : map.removeLayer(SATELLITE_LAYER_AND_SOURCE);
        map === null || map === void 0 ? void 0 : map.removeSource(SATELLITE_LAYER_AND_SOURCE);
    }
    const layers = map.getStyle().layers;
    fillLayers(map, layers, 1);
};
const fillLayers = (map, layers, opacity) => {
    layers.forEach((layer) => {
        if (layer.type === 'fill' && !layer.id.match(/(Building)/)) {
            map.setPaintProperty(layer.id, 'fill-opacity', opacity);
        }
    });
};
